import { ImageUploader } from "@/common/components/ImageUploader";
import MaskedTextField from "@/common/components/MaskedTextField";
import TextField from "@/common/components/TextField";
import { cnpjMask } from "@/common/constants/masks.constant";
import { simpleNationalOptantStrategy } from "@/common/constants/simpleNationalOptantOptions.constant";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import { commercialKindOptions } from "@/features/establishmentLeadsFunnel/constants/commercialKindOptions.constant";
import ContactInfoUpdateModal from "./ContactInfoUpdateModal";
import Accordion from "@/common/components/Accordion";
import AddressSection from "./AddressSection";

interface GeneralDataSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  establishmentCompanyIsPending?: boolean;
  disabled?: boolean;
}

const GeneralDataSection = ({ establishmentCompany, establishmentCompanyIsPending, disabled }: GeneralDataSectionProps) => {
  return (
    <Accordion
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      defaultOpen
      head={(
        <div className="flex items-center gap-3">
          {establishmentCompany &&
            <div onClick={(event) => {
              event.stopPropagation();
            }}>
              <ContactInfoUpdateModal
                establishmentMatrixBranchId={establishmentCompany.matrix_branch?.id ?? ''}
                establishmentCompanyId={establishmentCompany.id}
                generalInformation={establishmentCompany?.general_information}
                disabled={disabled}
              />
            </div>
          }

          <p className="text-lg font-bold">
            Dados Gerais
          </p>
        </div>
      )}
      body={(
        <div className="flex flex-col gap-4">
          <div className="flex gap-2">
            <div className="flex gap-2 w-full">
              <ImageUploader
                isLoading={false}
                label="Foto"
                name="profile-picture"
                accept="image/*"
                currentImageUrl={establishmentCompany?.general_information?.company_logo?.url || undefined}
                disabled
              />

              <MaskedTextField
                mask={cnpjMask}
                className="w-full mt-[14px]"
                label="CNPJ"
                value={establishmentCompany?.general_information?.cnpj}
                disabled
              />
            </div>

            <TextField
              label="Tipo de estabelecimento"
              className="w-full mt-[14px]"
              value={
                establishmentCompany?.matrix_branch?.commercial_kind
                  ? commercialKindOptions.find(
                    ({ value }) =>
                      value ===
                      establishmentCompany?.matrix_branch?.commercial_kind
                  )?.label
                  : undefined
              }
              disabled
            />
          </div>

          <div className="flex gap-2">
            <TextField
              label="Nome Fantasia"
              className="w-1/2"
              maxLength={64}
              value={establishmentCompany?.general_information?.fantasy_name}
              disabled
            />

            <TextField
              label="Nome Empresarial"
              className="w-1/2"
              maxLength={64}
              value={establishmentCompany?.general_information?.official_name}
              disabled
            />
          </div>

          <div className="flex gap-2">
            <TextField
              label="Endereço eletrônico"
              value={establishmentCompany?.general_information?.email}
              className="w-1/2"
              maxLength={64}
              disabled
            />
            <TextField
              label="Telefone"
              value={establishmentCompany?.general_information?.phone?.number}
              className="w-1/2"
              disabled
              name="phone.number"
            />
          </div>

          <TextField
            label="Optante pelo simples nacional"
            value={
              simpleNationalOptantStrategy[
              establishmentCompany?.general_information
                ?.simple_national_optant as keyof typeof simpleNationalOptantStrategy || 'false'
              ]
            }
            disabled
          />

          <div className="flex gap-2">
            <TextField
              label="IE (Inscrição Estadual)"
              maxLength={14}
              value={establishmentCompany?.general_information?.state_inscription}
              className="w-1/2"
              disabled
            />

            <TextField
              label="CNAE"
              maxLength={7}
              value={establishmentCompany?.general_information?.primary_cnae}
              className="w-1/2"
              disabled
            />
          </div>

          <TextField
            label="Bandeira"
            value={establishmentCompany?.general_information?.flag?.display_name}
            disabled
          />

          <AddressSection
            establishmentCompany={establishmentCompany}
            isPending={establishmentCompanyIsPending}
          />
        </div>
      )}
    />
  );
};

export default GeneralDataSection;
